import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import { useChatOnboarding } from './hooks/useChatOnboarding';
import { TChatOnboardingType } from './types';
import { ChatOnboardingContent } from '../../components/ChatOnboardingContent';

interface IChatOnboardingContainerProps {
  children: React.ReactElement;
  type: TChatOnboardingType;
}

const TEXT_MAP: Record<TChatOnboardingType, string> = {
  builder: 'Теперь можно написать застройщику в чате',
  consultant: 'Консультант подберёт квартиру по\u00a0вашим параметрам и\u00a0ответит на\u00a0вопросы',
};

// TODO: Удалить в CD-226254/CD-225148. Онбординги на месяц.
export const ChatOnboardingContainer: React.FC<IChatOnboardingContainerProps> = ({ children, type }) => {
  const { open, closeHandler } = useChatOnboarding(type);

  if (!open) {
    return children;
  }

  return (
    <OnboardingTooltip
      theme="blue"
      content={<ChatOnboardingContent>{TEXT_MAP[type]}</ChatOnboardingContent>}
      placement="bottom-start"
      portal={false}
      open={open}
      onClose={closeHandler}
      flip={false}
    >
      <div>{children}</div>
    </OnboardingTooltip>
  );
};
